import { useId } from "react";
import { useTranslation } from "react-i18next";

import { useGetProfileSuspense, useListNotifications, useLogout } from "@/api/bale";

import { Dropdown } from "./Dropdown";
import { Icon } from "./Icon";
import { MenuItem } from "./MenuItem";
import { Tomato } from "./Tomato";

export function ProfileDropdown() {
  const { t } = useTranslation();
  const profile = useGetProfileSuspense("@me", { query: { select: (data) => data.data.profile } });
  const notifications = useListNotifications(
    { limit: 0, status: ["Unread"] },
    { query: { select: (data) => data.data } },
  );
  const id = useId();

  const logout = useLogout({
    mutation: {
      onSuccess: () => {
        window.location.href = "/join";
      },
    },
  });

  return (
    <>
      <button
        type="button"
        className="flex min-w-32 shrink-1 cursor-pointer flex-row items-center gap-4 px-4"
        aria-label={t("account-menu")}
        popoverTarget={id}
      >
        <div className="flex max-w-64 grow basis-0 flex-col items-end justify-center overflow-hidden">
          <p className="max-w-full truncate font-interest">{profile.data.display_name ?? profile.data.id}</p>
          {profile.data.display_name && profile.data.display_name !== profile.data.id && (
            <p className="max-w-full truncate font-disinterest text-placeholder">{profile.data.id}</p>
          )}
        </div>
        <img src="/turtle.svg" className="h-12" alt="Avatar turtle" />
        {!!notifications.data?.page_info.total_count && <Tomato className="absolute top-0 left-0" attention="notice" />}
      </button>

      <Dropdown
        id={id}
        popover="auto"
        className="absolute -mt-2 mr-2 min-w-[anchor-size(width)] [position-area:bottom]"
      >
        <MenuItem to={`/profile/${profile.data.id}`}>
          <Icon name="smile" />
          {t("view-profile")}
        </MenuItem>
        <MenuItem to="/friends">
          <Icon name="users" />
          {t("friends")}
        </MenuItem>
        <MenuItem to="/settings">
          <Icon name="settings" />
          {t("settings")}
        </MenuItem>
        <MenuItem to="/notifications">
          <Icon name="bell" />
          {t("notifications")}
          {!!notifications.data?.page_info.total_count && <Tomato className="ml-auto" attention="notice" />}
        </MenuItem>
        <MenuItem onClick={() => logout.mutate()} className="text-danger">
          <Icon name="log-out" />
          {t("log-out")}
        </MenuItem>
      </Dropdown>
    </>
  );
}
